import React from 'react'
import { string } from 'prop-types'

import { Card, CardBlock, Row, Col, Image } from 'components/qstrap'
import Typography from 'components/atoms/Typography'

const Testimony = ({ testimony, name, img, imgAlt }) => (
  <div className="testimony">
    <Card className="testimony__card">
      <CardBlock className="testimony__content p-a-md">
        <Row>
          <Col md="2 text-center">
            <Image src={img || '/assets/img/placeholder-profile.svg'} alt={imgAlt || name}/>
          </Col>
          <Col md="10">
            <Typography component="p" variant="body" className="font-weight-bold">
              {name}
            </Typography>
            <Typography component="p" variant="body">
              { testimony }
            </Typography>
          </Col>
        </Row>
      </CardBlock>
    </Card>
  </div>
)

Testimony.propTypes = {
  testimony: string,
  name: string,
  img: string,
  imgAlt: string,
}

export default Testimony
